import { render, staticRenderFns } from "./armonile.vue?vue&type=template&id=3a017d5f"
import script from "./armonile.vue?vue&type=script&lang=js"
export * from "./armonile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports